export { ViewComponent } from '../src/renderer/ViewComponent.tsx';
export type { ViewComponentProps } from '../src/renderer/ViewComponent.tsx';
